module.exports = __webpack_public_path__ + "static/media/failed.f682ee2f.png";